import { TextField } from '@mui/material';
import { FieldProps } from 'formik';

export default function FormTextInput(props: FieldProps) {
    const { form, field, ...otherProps } = props;
    return (
        <TextField
            id={field.name}
            name={field.name}
            value={field.value ?? ''}
            onChange={(ev: React.ChangeEvent<any>) => {
                form.setFieldTouched(field.name).catch(console.error);
                field.onChange(ev);
            }}
            onBlur={field.onBlur}
            error={form.touched[field.name] && Boolean(form.errors[field.name])}
            helperText={(form.touched[field.name] && form.errors[field.name]) as string}
            {...otherProps}
        />
    );
}
